subscribe(
  PUB_SUB_EVENTS.variantChange,
  customHandleVariantChange
);

function customHandleVariantChange({ data: { html, sectionId, variant } }) {
  filterMedia(html)
}

function filterMedia(html) {
  $("[thumbnail-variant]").hide();

  var selected_variant = customGetSelectedVariant(html)?.featured_media?.alt;

  var selected_attribute = '[thumbnail-variant="' + selected_variant + '"]';

  if (selected_variant == selected_variant) {
    $(selected_attribute).show();
  }
}

// customGetSelectedVariant is a copy of ProductInfo.getSelectedVariant
function customGetSelectedVariant(productInfoNode) {
  const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
  return !!selectedVariant ? JSON.parse(selectedVariant) : null;
}